/** Same-origin return path for the MCP consent page. Nothing else is accepted. */
export function isSafeConnectedAppsPath(value: string): boolean {
  if (!value.startsWith("/connected-apps")) return false;
  if (value.length > 2048) return false;
  if (value.includes("\\") || value.includes("://") || value.includes("\0")) return false;
  return /^\/connected-apps(?:\?[^#]*)?$/.test(value);
}
